import type {
	Extension,
	ExtensionHandler,
	Parameters as ExtensionParameters,
} from '@atlaskit/editor-common/extensions';

import type { ADFRendererProps } from '@confluence/adf-renderer/entry-points/ADFRendererComponent.ts';
import {
	EXTENSION_KEY,
	EXTENSION_TYPE,
} from '@confluence/fabric-extension-lib/entry-points/extensionConstants.ts';
import { expValEquals, expVal } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';

export function createExtensionHandlersWithoutSSR(
	delegates: ADFRendererProps['extensionHandlers'],
): ADFRendererProps['extensionHandlers'] {
	const extensionType = EXTENSION_TYPE.MACRO_CORE;
	const delegate = getExtensionRenderer(delegates?.[extensionType]);

	if (delegate) {
		return {
			[extensionType]: function extensionHandler(ext) {
				if (
					(ext.extensionKey === EXTENSION_KEY.TOC ||
						(ext.extensionKey === EXTENSION_KEY.TEAM_CALENDARS &&
							expValEquals('cc-engagement-team-calendar-macro-afm-migration', 'isEnabled', true)) ||
						(ext.extensionKey === EXTENSION_KEY.HIDE &&
							expVal('platform_editor_hide_extension_renderer_support', 'isEnabled', false)) ||
						(ext.extensionKey?.startsWith(EXTENSION_KEY.NATIVE_EMBED) &&
							(expVal('cc-maui-experiment', 'isEnabled', false) ||
								fg('platform_native_embeds_rollout_non_maui_experience')))) &&
					ext.extensionType === extensionType
				) {
					return delegate.apply(this, arguments as unknown as Parameters<ExtensionHandler>);
				} else {
					return null;
				}
			},
		};
	}
}

function getExtensionRenderer<T extends ExtensionParameters>(
	extensionHandler: Extension<T> | ExtensionHandler<T> | undefined,
): ExtensionHandler<T> | undefined {
	if (extensionHandler && typeof extensionHandler === 'object') {
		return extensionHandler.render;
	} else {
		return extensionHandler;
	}
}
